import { FC } from 'react'
import {
  Text,
  ErrorMessage,
  GreyGrey60,
  Primary13Regular,
  Flex
} from '@sequencehq/core-components'
import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import Spinner from 'components/Loading/Spinner'
import { GoCardlessMandate } from '../GoCardlessMandate'

export const GoCardlessMandatesListWidget: FC<{ customerId: string }> = ({
  customerId
}) => {
  const { data, isPending, isError } = useQuery(
    dashboardv99990101Client.getGoCardlessCollectionsMandate,
    { customerId }
  )

  const mandates = data?.mandates ?? []

  if (isPending) {
    return (
      <Flex justifyContent="center">
        <Spinner />
      </Flex>
    )
  }

  if (isError) {
    return <ErrorMessage data-testid="gocardless.mandates.error" />
  }

  if (mandates.length === 0) {
    return (
      <Text
        {...Primary13Regular}
        color={GreyGrey60}
        textAlign="center"
        data-testid="gocardless.mandates.empty"
      >
        No mandates for this customer
      </Text>
    )
  }

  return (
    <Flex flexDirection="column" gap="8px">
      {mandates.map(mandate => (
        <GoCardlessMandate
          key={mandate.id}
          mandateId={mandate.id}
          externalMandateId={mandate.externalMandateId}
          status={mandate.status}
          createdAt={mandate.createdAt}
        />
      ))}
    </Flex>
  )
}
